"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAdminAppInstalled = void 0;
var qs = require("qs");
exports.workspaceAdminAppInstalled = function (axios) {
    return {
        getWorkspaceAdminAppInstalled: function (request) {
            return axios.get('/apps/installed', request);
        },
        postWorkspaceAdminAppsAppNoInstalled: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.post("/apps/" + appNo + "/installed", request.data);
        },
        getAppsAppNoInstalledAppInstalledNo: function (request) {
            var _a = request.pathParams, appNo = _a.appNo, appInstalledNo = _a.appInstalledNo;
            var query = qs.stringify(request.params);
            return axios.get("/apps/" + appNo + "/installed/" + appInstalledNo + "?" + query);
        },
        deleteAppsAppNoInstalledAppInstalledNo: function (request) {
            var _a = request.pathParams, appNo = _a.appNo, appInstalledNo = _a.appInstalledNo;
            var query = qs.stringify(request.params);
            return axios.delete("/apps/" + appNo + "/installed/" + appInstalledNo + "?" + query);
        },
        getAppsAppNoInstalled: function (request) {
            var appNo = request.pathParams.appNo;
            var query = qs.stringify(request.params);
            return axios.get("/apps/" + appNo + "/installed?" + query);
        },
        deleteAppsAppNoInstalled: function (request) {
            var appNo = request.pathParams.appNo;
            var query = qs.stringify(request.params);
            return axios.delete("/apps/" + appNo + "/installed?" + query);
        },
        getAppsInstalledSimple: function (request) {
            return axios.get('/apps/installed/simple', request);
        },
        getAppsAppNoInstalledMalls: function (request) {
            var appNo = request.pathParams.appNo;
            return axios.get("/apps/" + appNo + "/installed/malls");
        }
    };
};
